import { infiniteQueryOptions } from "@tanstack/react-query";
import { apiGet } from "../client";
import type { Job, JobListParams, Page } from "../types";
import { keepPreviousData } from "@tanstack/react-query";
import { qk } from "./qk";

export const jobsInfiniteQuery = (params: JobListParams = {}) =>
  infiniteQueryOptions({
    queryKey: qk.jobs.list(params),
    queryFn: ({ pageParam }: { pageParam: string | null }) => {
      const search = new URLSearchParams();
      if (params.q) search.set("q", params.q);
      if (params.type) search.set("type", params.type);
      search.set("limit", "20");
      if (pageParam) search.set("cursor", pageParam);
      return apiGet<Page<Job>>(`/api/jobs?${search.toString()}`);
    },
    initialPageParam: null as string | null,
    getNextPageParam: (lastPage: Page<Job>) => lastPage.nextCursor,
    staleTime: 120_000, // plan §5: catalog list
    placeholderData: keepPreviousData,
  });
